// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const AlertTriangleLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M3 20h18.526L12.263 4 3 20Zm10.105-2.526h-1.684V15.79h1.684v1.684Zm0-3.369h-1.684v-3.368h1.684v3.368Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const AlertTriangleLineOffset: IconOffset = {
    vertical: 16, // Store Custom Code
    horizontal: 12, // Store Custom Code
};

export default React.memo(AlertTriangleLine);
